(() => {
  const root = document.querySelector('[data-sb-signup-popup]');
  const debugDock = document.querySelector('[data-sb-signup-popup-debug-dock]');
  const debugDockToggle = document.querySelector('[data-sb-signup-popup-debug-toggle]');
  const debugCountdownButton = document.querySelector('[data-sb-signup-popup-debug-countdown]');
  const debugCountdownState = debugCountdownButton?.querySelector('[data-sb-signup-popup-debug-countdown-state]');
  if (!root) return;
  const pageSuppressesAutoOpen = root.dataset.autoOpenSuppressed === 'true' || Boolean(window.SBHoustonggReferral?.current);

  debugDockToggle?.addEventListener('click', () => {
    const opening = debugDock?.hidden !== false;
    if (debugDock) debugDock.hidden = !opening;
    debugDockToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });

  debugCountdownButton?.addEventListener('click', () => {
    const forceVisible = debugCountdownButton.getAttribute('aria-pressed') !== 'true';
    document.documentElement.toggleAttribute('data-sb-announcement-countdown-debug', forceVisible);
    debugCountdownButton.setAttribute('aria-pressed', forceVisible ? 'true' : 'false');
    if (debugCountdownState) debugCountdownState.textContent = forceVisible ? ': on' : ': off';
    document.dispatchEvent(new CustomEvent('sb:announcement-countdown-debug'));
  });

  const dialog = root.querySelector('[data-sb-signup-popup-dialog]');
  const backdrop = root.querySelector('[data-sb-signup-popup-backdrop]');
  const closeButton = root.querySelector('[data-sb-signup-popup-close]');
  const statePanels = [...root.querySelectorAll('[data-sb-signup-popup-state]')];
  const forms = [...root.querySelectorAll('[data-sb-signup-popup-form]')];
  const countdownRoot = root.querySelector('[data-sb-signup-popup-countdown]');
  let countdownTimer = 0;

  let lastFocused = null;
  let selectedInterest = '';
  let pageBackdrop = null;

  const mountPageBackdrop = () => {
    // Keep Safari's sampled top color in step with the signup backdrop lifecycle.
    document.documentElement.classList.add('sb-signup-popup-open');
    if (pageBackdrop?.isConnected) return;
    pageBackdrop = document.createElement('div');
    pageBackdrop.className = 'sb-modal-page-backdrop sb-modal-page-backdrop--signup';
    pageBackdrop.setAttribute('aria-hidden', 'true');
    document.body.prepend(pageBackdrop);
  };

  const unmountPageBackdrop = () => {
    document.documentElement.classList.remove('sb-signup-popup-open');
    pageBackdrop?.remove();
    pageBackdrop = null;
  };

  // Display rules: open immediately; artwork readiness is independent. The
  // popup intentionally becomes the LCP element for eligible visitors and is
  // engineered to paint fast (parse-time high-priority fetch in the Liquid);
  // it never opens while the cookie banner is visible. A dismiss snoozes for
  // 5 days (matching the old Klaviyo cadence), a signup silences for good.
  const DISMISS_SNOOZE_MS = 5 * 86400000;
  const STORAGE_KEY = 'sb-signup-popup';

  // Gentle scroll lock: the popup wants the page scrollbar hidden while the
  // DOCUMENT stays scrollable in layout, so Safari's browser bars keep
  // whatever state they are in - a fixed-body lock removed scrollability and
  // made Safari force-expand the bars on teaser opens and paint a mismatch
  // band on mid-scroll opens. The sb-scroll-locked classes are owned by ONE
  // manager (syncPageScrollLock in header-drawer.js, mode 'gentle', keyed off
  // html.sb-signup-popup-open) - the popup only notifies it. Two independent
  // writers of those classes used to strip each other's lock and could strand
  // the hidden scrollbar past close. In-flight momentum (which used to eat
  // the first taps on the close button) is killed locally by pinning the
  // scroll position for the first moments: Safari cancels a momentum
  // animation whenever the scroll position is set programmatically. New
  // gestures are already blocked by the popup's touch guard.
  let pageScrollLocked = false;
  let scrollPinFrame = 0;
  const notifyScrollLockManager = () => {
    document.dispatchEvent(new CustomEvent('sb:signup-popup:state-change'));
  };
  const lockPageScroll = () => {
    if (pageScrollLocked) return;
    pageScrollLocked = true;
    notifyScrollLockManager();
    const pinnedY = window.scrollY || document.documentElement.scrollTop || 0;
    const pinUntil = performance.now() + 700;
    const pin = () => {
      if (!pageScrollLocked) return;
      if ((window.scrollY || 0) !== pinnedY) window.scrollTo(0, pinnedY);
      if (performance.now() < pinUntil) {
        scrollPinFrame = window.requestAnimationFrame(pin);
      }
    };
    scrollPinFrame = window.requestAnimationFrame(pin);
  };
  const unlockPageScroll = () => {
    if (!pageScrollLocked) return;
    pageScrollLocked = false;
    window.cancelAnimationFrame(scrollPinFrame);
    notifyScrollLockManager();
  };

  const readMemory = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
    } catch (_) {
      return {};
    }
  };

  const writeMemory = (patch) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readMemory(), ...patch }));
    } catch (_) {}
  };

  // Fresh cookie state keeps the personalized offer and checkout code aligned.
  const defaultDiscountCode = root.dataset.discountCode || '';
  const offerSelectors = {
    affiliateBadge: '[data-sb-signup-popup-offer-badge]',
    affiliateIntroBody: '[data-sb-signup-popup-intro-body]',
    affiliateButtonLabel: '[data-sb-signup-popup-offer-button]',
    affiliateSuccessTitle: '[data-sb-signup-popup-success-title]',
  };
  const offerNodes = root.querySelectorAll(Object.values(offerSelectors).join(',') + ',[data-sb-signup-popup-offer],.sb-signup-popup__title-accent,[data-sb-signup-popup-code-group] .sb-discount-voucher span');
  const defaultOfferMarkup = new Map(Array.from(offerNodes, node => [node, node.innerHTML]));
  const teaserTitle = document.querySelector('.sb-signup-popup-teaser__copy-title');
  const defaultTeaserTitle = teaserTitle?.textContent || '';
  const syncAffiliateOffer = () => {
    const affiliate = window.SBAffiliateState?.read();
    const personalized = template => (template || '').split('__AFFILIATE__').join(affiliate?.affiliateName || '');
    defaultOfferMarkup.forEach((markup, node) => { node.innerHTML = markup; });
    root.dataset.discountCode = affiliate?.discountCode || defaultDiscountCode;
    const teaserQualifier = document.querySelector('.sb-signup-popup-teaser__copy-subtitle');
    if (teaserQualifier) teaserQualifier.hidden = Boolean(affiliate);
    if (teaserTitle) teaserTitle.textContent = affiliate ? personalized(root.dataset.affiliateTitle) : defaultTeaserTitle;
    if (!affiliate) return;
    Object.entries(offerSelectors).forEach(([key, selector]) => {
      root.querySelectorAll(selector).forEach(node => {
        if (key !== 'affiliateIntroBody') {
          node.textContent = personalized(root.dataset[key]);
          return;
        }
        const parts = (root.dataset[key] || '').split('__AFFILIATE__');
        node.replaceChildren(...parts.flatMap((part, index) => {
          const text = document.createTextNode(part);
          if (index === 0) return [text];
          const name = document.createElement('strong');
          name.className = 'weight-bold';
          name.textContent = affiliate.affiliateName;
          return [name, text];
        }));
      });
    });
    const voucher = root.querySelector('[data-sb-signup-popup-code-group] .sb-discount-voucher span');
    if (voucher) voucher.textContent = affiliate.discountCode;
    const offer = root.querySelector('[data-sb-signup-popup-offer]');
    const percentage = affiliate.displayPercentage ?? affiliate.discountPercentage ?? root.dataset.affiliateDiscountDepth;
    const discount = Number(percentage) > 0 && Number(percentage) <= 100 ? `${Number(percentage)}%` : '';
    root.querySelectorAll('.sb-signup-popup__title-accent').forEach(node => { if (discount) node.textContent = discount; });
    if (offer) offer.innerHTML = (root.dataset.affiliateOffer || '').split('__AFFILIATE_DISCOUNT__').join(discount);
  };

  const setFormError = (form, message) => {
    const errorNode = form.querySelector('[data-sb-signup-popup-error]');
    const errorTextNode = form.querySelector('[data-sb-signup-popup-error-text]');
    form.querySelector('[data-sb-signup-popup-email-field]')?.classList.toggle('is-error', Boolean(message));
    if (!errorNode) return;
    if (errorTextNode) errorTextNode.textContent = message || '';
    errorNode.hidden = !message;
  };

  const clearErrors = () => forms.forEach((form) => setFormError(form, ''));

  // Typing clears the error state, matching every other form surface.
  document.querySelectorAll('[data-sb-signup-popup-email]').forEach((input) => {
    input.addEventListener('input', () => {
      const form = input.closest('[data-sb-signup-popup-form]');
      if (form) setFormError(form, '');
    });
  });

  // Signup counter: real 30-day base, cosmetic +1 ticks while the popup is
  // open so the number feels alive. Uses the vendored <number-flow> element
  // when available and falls back to the server-rendered text otherwise.
  const countHosts = [...root.querySelectorAll('[data-sb-signup-popup-count]')];
  let signupCount = Number.parseInt(countHosts[0]?.dataset.sbSignupPopupCount || '', 10);

  // The count is a rolling 30-day figure. If the snapshot is stale (worker not
  // yet running or paused), decay it linearly toward zero over 30 days so we
  // never overstate - fresh data makes this a no-op.
  const countGeneratedAt = Date.parse(countHosts[0]?.dataset.sbSignupPopupCountGeneratedAt || '');
  if (Number.isFinite(signupCount) && Number.isFinite(countGeneratedAt)) {
    const ageDays = Math.max(0, (Date.now() - countGeneratedAt) / 86400000);
    signupCount = Math.round(signupCount * Math.max(0, 1 - ageDays / 30));
  }
  let countFlowElements = [];
  let countTickTimer = 0;

  if (countHosts.length > 0 && Number.isFinite(signupCount)) {
    const pageLocale = document.documentElement.lang || undefined;
    const formattedCount = new Intl.NumberFormat(pageLocale).format(signupCount);
    countHosts.forEach((host) => {
      host.textContent = formattedCount;
    });
    if ('customElements' in window) {
      customElements.whenDefined('number-flow').then(() => {
        countFlowElements = countHosts.map((host) => {
          const flow = document.createElement('number-flow');
          flow.locales = pageLocale;
          flow.update(signupCount);
          // the theme's ::selection cannot pierce the shadow root, so the
          // digits would fall back to the browser's default highlight
          if (flow.shadowRoot) {
            const selectionStyle = document.createElement('style');
            selectionStyle.textContent =
              '::selection { background: var(--sb-color-primary-500); color: var(--sb-color-always-white); }';
            flow.shadowRoot.appendChild(selectionStyle);
          }
          host.replaceChildren(flow);
          return flow;
        });
        if (!root.hidden && !document.hidden) startCountTicks();
      });
    }
  }

  const stopCountTicks = () => {
    window.clearTimeout(countTickTimer);
    countTickTimer = 0;
  };

  const scheduleCountTick = () => {
    countTickTimer = window.setTimeout(() => {
      signupCount += 1;
      countFlowElements.forEach((flow) => flow.update(signupCount));
      scheduleCountTick();
    }, 2500 + Math.random() * 1000);
  };

  const startCountTicks = () => {
    if (countFlowElements.length === 0 || !Number.isFinite(signupCount)) return;
    stopCountTicks();
    scheduleCountTick();
  };

  // No cosmetic ticking in hidden tabs - it burns main-thread and battery
  // for nobody; resume when the visitor comes back with the popup open.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopCountTicks();
    } else if (!root.hidden) {
      startCountTicks();
    }
  });

  const COUNTDOWN_DURATION_MS = 30 * 60 * 1000;

  const startCountdown = () => {
    if (!countdownRoot) return;
    const expiresAt = Date.now() + COUNTDOWN_DURATION_MS;
    const pad = (value) => `${value}`.padStart(2, '0');
    const tick = () => {
      const remaining = Math.max(0, expiresAt - Date.now());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor(remaining / 60000) % 60;
      const seconds = Math.floor(remaining / 1000) % 60;
      const text = hours > 0
        ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
        : `${pad(minutes)}:${pad(seconds)}`;
      // The theme font has proportional digits, so each character gets a
      // fixed-width slot - the pill stays perfectly still while centered.
      const chars = [...text];
      if (countdownRoot.childElementCount !== chars.length) {
        countdownRoot.replaceChildren(...chars.map((ch) => {
          const slot = document.createElement('span');
          slot.className = ch === ':'
            ? 'sb-signup-popup__countdown-char sb-signup-popup__countdown-char--colon'
            : 'sb-signup-popup__countdown-char';
          slot.textContent = ch;
          return slot;
        }));
      } else {
        chars.forEach((ch, i) => {
          const slot = countdownRoot.children[i];
          if (slot.textContent !== ch) slot.textContent = ch;
        });
      }
      if (remaining <= 0) window.clearInterval(countdownTimer);
    };
    window.clearInterval(countdownTimer);
    tick();
    countdownTimer = window.setInterval(tick, 1000);
  };

  // Anchor the hero image's focal point to the center of the free area
  // (right of the card on desktop, above it on mobile) from real geometry,
  // so it stays correct across states, viewports, and the 60px edge guard.
  const heroImage = root.querySelector('.sb-signup-popup__hero:not(.sb-signup-popup__hero--alt)');
  const heroAltImages = Array.from(root.querySelectorAll('[data-sb-signup-popup-hero-alt]'));
  const syncHeroAnchor = () => {
    if (!heroImage || !dialog || root.hidden) return;
    // Settled geometry only: offset* ignores transforms, while a bounding
    // rect reports the card's entrance/breakpoint transform mid-flight. The
    // card's transform keeps transitioning for ~1.6s AFTER the last resize
    // event of a window drag, so a rect-based anchor froze that in-flight
    // position forever (desktop -> narrow left the render off screen). The
    // shell is display:contents, so the offsets are viewport coordinates on
    // the fixed full-inset root. On desktop the settled translate(-50%, -50%)
    // centers the card on its left/top values, so offsetLeft IS the card's
    // horizontal center.
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const cardRight = dialog.offsetLeft + dialog.offsetWidth / 2;
    const cardTop = dialog.offsetTop;
    const anchorX = isDesktop ? (cardRight + window.innerWidth) / 2 : window.innerWidth / 2;
    const anchorY = isDesktop ? window.innerHeight / 2 : cardTop / 2;
    // Inline vars beat the rule-level defaults, so all colorway layers need
    // them for the crossfade to stay registered.
    [heroImage, ...heroAltImages].forEach((image) => {
      if (!image) return;
      image.style.setProperty('--sb-signup-popup-hero-anchor-x', `${Math.round(anchorX)}px`);
      image.style.setProperty('--sb-signup-popup-hero-anchor-y', `${Math.round(anchorY)}px`);
    });
  };
  // Load alternate colorways only after the primary render is ready.
  // Keep the primary visible until every alternate has decoded, and skip
  // the additional downloads for reduced-motion visitors.
  let heroAltArmed = false;
  const armHeroAlt = () => {
    if (root.hidden || heroAltArmed || !heroAltImages.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    heroAltArmed = true;
    const readyImages = heroAltImages.map((image) => {
      image.fetchPriority = 'low';
      image.sizes = image.dataset.sizes || '';
      image.srcset = image.dataset.srcset || '';
      image.src = image.dataset.src || '';
      return image.decode().catch(() => {
        if (image.complete) {
          if (image.naturalWidth > 0) return;
          throw new Error('Signup colorway failed to load');
        }
        return new Promise((resolve, reject) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', reject, { once: true });
        });
      });
    });
    Promise.all(readyImages).then(() => {
      if (heroAltImages.every((image) => image.naturalWidth > 0)) {
        root.classList.add('is-hero-alt-ready');
      }
    }).catch(() => {
      // An unavailable alternate leaves the primary render visible.
    });
  };
  // Re-anchor on every resize: with the touch guard and fixed-body lock the
  // bars no longer move while the popup is open, so resize events are rare
  // and correcting for them (e.g. a popup that opened mid-scroll while the
  // bars were still settling) beats freezing a mid-scroll anchor in place.
  window.addEventListener('resize', () => syncHeroAnchor(), { passive: true });
  // The anchor formula switches shape at the layout breakpoint; re-sync on
  // the flip itself so environments that coalesce or suppress resize events
  // during a viewport change still land on the right formula.
  window.matchMedia('(min-width: 750px)').addEventListener('change', () => syncHeroAnchor());

  // iOS lets touch panning through html/body overflow:hidden, which
  // collapses the browser bars and resizes the popup mid-view. Pans starting
  // outside the card are blocked entirely; inside the card the gesture may
  // scroll the card's own overflow, but it is swallowed when nothing
  // overflows and at the scroll boundaries - Safari ignores
  // overscroll-behavior exactly when the container has nothing left to
  // scroll, which is how the gesture was chaining to the page.
  let dialogTouchStartY = 0;
  root.addEventListener('touchstart', (event) => {
    dialogTouchStartY = event.touches[0] ? event.touches[0].clientY : 0;
  }, { passive: true });
  root.addEventListener('touchmove', (event) => {
    if (!dialog || !dialog.contains(event.target)) {
      event.preventDefault();
      return;
    }
    const touchY = event.touches[0] ? event.touches[0].clientY : dialogTouchStartY;
    const pullingDown = touchY > dialogTouchStartY;
    const canScroll = dialog.scrollHeight > dialog.clientHeight;
    const atTop = dialog.scrollTop <= 0;
    const atBottom = dialog.scrollTop + dialog.clientHeight >= dialog.scrollHeight - 1;
    if (!canScroll || (pullingDown && atTop) || (!pullingDown && atBottom)) {
      event.preventDefault();
    }
  }, { passive: false });

  // Bar-collapse and rotation resizes make number-flow re-measure mid-
  // transition, briefly overlapping the counter text - snap instead of
  // animating while the viewport is changing.
  let viewportCalmTimer = 0;
  window.visualViewport?.addEventListener('resize', () => {
    countFlowElements.forEach((flow) => { flow.animated = false; });
    window.clearTimeout(viewportCalmTimer);
    viewportCalmTimer = window.setTimeout(() => {
      countFlowElements.forEach((flow) => { flow.animated = true; });
    }, 300);
  });

  // Artwork preparation is independent of form display. Reveal the artwork
  // once decoded; a slow or failed image never blocks the form. Using
  // the real responsive <img> lets the browser choose the correct srcset
  // candidate and decode it once; eligibility-aware priority is applied at
  // parse time in the Liquid so only visitors who will actually see the
  // popup pay for the early fetch.
  const markHeroReady = () => {
    root.classList.add('is-hero-ready');
    armHeroAlt();
  };
  let imagePreparationStarted = false;
  const preparePopupImage = async () => {
    if (imagePreparationStarted || !heroImage) return;
    imagePreparationStarted = true;
    const image = heroImage;
    // The parse-time promoter in the Liquid may have already set 'high' for
    // eligible visitors; never downgrade an in-flight high-priority fetch.
    if (image.fetchPriority !== 'high') {
      image.fetchPriority = 'low';
    }
    image.loading = 'eager';
    try {
      await image.decode();
    } catch (_) {}
    if (image.complete && image.naturalWidth > 0) {
      markHeroReady();
    } else {
      image.addEventListener('load', async () => {
        try { await image.decode(); } catch (_) {}
        if (image.naturalWidth > 0) markHeroReady();
      }, { once: true });
    }
  };

  const uniqueId = () => {
    if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
  };

  const anonymousId = () => {
    const memory = readMemory();
    if (typeof memory.anonymousId === 'string' && memory.anonymousId.length >= 10) return memory.anonymousId;
    const nextId = uniqueId();
    writeMemory({ anonymousId: nextId });
    return nextId;
  };

  const showState = (name) => {
    if (name === 'success') startCountdown();
    const focusedPanel = statePanels.find(panel => panel.contains(document.activeElement));
    statePanels.forEach((panel) => {
      panel.hidden = panel.dataset.sbSignupPopupState !== name;
    });
    if (focusedPanel?.hidden && !root.hidden) dialog?.focus({ preventScroll: true });
  };

  const isOpen = () => !root.hidden;

  const open = () => {
    syncAffiliateOffer();
    lastFocused = document.activeElement;
    const wasHidden = root.hidden;
    // the hidden attribute drives the entire open/close choreography:
    // @starting-style animates the entry, allow-discrete holds the exit
    mountPageBackdrop();
    root.hidden = false;
    lockPageScroll();
    preparePopupImage();
    if (root.classList.contains('is-hero-ready')) {
      armHeroAlt();
    }
    showState('intro');
    startCountTicks();
    clearErrors();
    selectedInterest = '';
    // focus the dialog (not the input) so assistive tech lands in the modal
    // without popping the keyboard or autofill over the content
    dialog?.focus({ preventScroll: true });
    // anchor the hero once per opening (so state swaps never shift it);
    // synchronous, so the anchor is committed before the first visible frame
    if (wasHidden) {
      syncHeroAnchor();
    }
  };

  const close = () => {
    window.clearInterval(countdownTimer);
    stopCountTicks();
    root.hidden = true;
    // unmount first: the scroll-lock manager keys off html.sb-signup-popup-open,
    // so the class must be gone before unlockPageScroll() notifies it
    unmountPageBackdrop();
    unlockPageScroll();
    if (lastFocused instanceof HTMLElement) lastFocused.focus();

    const finishClose = () => {
      writeMemory({ dismissedAt: Date.now() });
      syncTeaser();
    };

    if (document.visibilityState === 'hidden') {
      finishClose();
      return;
    }

    window.requestAnimationFrame(() => {
      window.setTimeout(finishClose, 0);
    });
  };

  const subscribe = async (email) => {
    const companyId = `${root.dataset.companyId || ''}`.trim();
    const listId = `${root.dataset.listId || ''}`.trim();

    if (!companyId || !listId) return false;

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: `${root.dataset.customSource || 'Website signup popup'}`,
              profile: { data: { type: 'profile', attributes: { email, anonymous_id: anonymousId() } } },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      }
    );
    if (!response.ok && response.status !== 202) return false;

    // Identification is optional tracking after an accepted subscription.
    try {
      if (typeof window.klaviyo?.identify === 'function') {
        Promise.resolve(window.klaviyo.identify({ email })).catch(() => {});
      } else if (Array.isArray(window._learnq)) {
        window._learnq.push(['identify', { email }]);
      }
    } catch (_) {}
    return true;
  };

  // Record the completed signup and optional interest answer. Fire and forget:
  // a lost analytics event must never cost the signup. The debug dock only
  // renders on unpublished themes, so test submits stay out of production data.
  const trackSignupEvent = async (email) => {
    const companyId = `${root.dataset.companyId || ''}`.trim();
    if (!companyId || debugDock) return;
    const properties = {
      source: 'popup',
      // page + device_type mirror Klaviyo's native form-submit event, so
      // flows keyed on the signup page (e.g. the Gamer tagging flow's
      // "page contains for-gamers") translate 1:1 to this metric
      page: window.location.href,
      device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    };
    if (selectedInterest) properties.interest = selectedInterest;
    try {
      await fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        keepalive: true,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties,
              metric: { data: { type: 'metric', attributes: { name: 'soundbrenner.com signup' } } },
              profile: { data: { type: 'profile', attributes: { email, anonymous_id: anonymousId() } } },
            },
          },
        }),
      });
    } catch (_) {}
  };

  const trackDiscountResult = async (email, result) => {
    const companyId = `${root.dataset.companyId || ''}`.trim();
    if (!companyId || debugDock) return;
    try {
      const properties = {
        source: 'popup',
        discount_applied: result.applied,
        discount_reason: result.reason,
        discount_stage: result.stage,
        discount_http_status: result.httpStatus,
      };
      await fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        keepalive: true,
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties,
              metric: {
                data: {
                  type: 'metric',
                  attributes: { name: 'soundbrenner.com signup popup discount result' },
                },
              },
              profile: { data: { type: 'profile', attributes: { email, anonymous_id: anonymousId() } } },
            },
          },
        }),
      });
    } catch (_) {}
  };

  // Apply through the Ajax cart first so cart UI and checkout share the same
  // Shopify state. The URL endpoint remains a fallback for a page where the
  // cart system failed to initialize. One code intentionally replaces any
  // previously injected code. Affiliate visitors retain their affiliate code.
  const applyDiscountToCheckout = async () => {
    let stage = 'configuration';
    let httpStatus = 0;
    const result = (applied, reason) => ({ applied, reason, stage, httpStatus });
    const code = `${window.SBAffiliateState?.read()?.discountCode || root.dataset.discountCode || ''}`.trim();
    if (!code) return result(false, 'missing_code');
    const hasAcceptedCode = (cart) => {
      if (typeof window.SBCart?.hasAcceptedDiscountCode === 'function') {
        return window.SBCart.hasAcceptedDiscountCode(cart, code);
      }
      const normalizedCode = code.toLowerCase();
      const applications = Array.isArray(cart?.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];
      if (applications.some((entry) => (
        `${entry?.type || ''}`.toLowerCase() === 'discount_code'
        && `${entry?.title || ''}`.trim().toLowerCase() === normalizedCode
      ))) return true;
      const attemptedCode = (Array.isArray(cart?.discount_codes) ? cart.discount_codes : []).find((entry) => (
        `${entry?.code || ''}`.trim().toLowerCase() === normalizedCode
      ));
      return Boolean(attemptedCode && (attemptedCode.applicable === true || Number(cart?.item_count) === 0));
    };
    const applyThroughDiscountRoute = async () => {
      stage = 'discount_route';
      httpStatus = 0;
      const localeRoot = String(root.dataset.localeRoot || '/').replace(/\/$/, '');
      const cartJsonUrl = `${localeRoot}/cart.js`;
      const redirect = encodeURIComponent(cartJsonUrl);
      const response = await fetch(`${localeRoot}/discount/${encodeURIComponent(code)}?redirect=${redirect}`, {
        credentials: 'same-origin',
      });
      httpStatus = response.status;
      if (!response.ok) throw new Error('discount_http_error');
      try {
        return await response.json();
      } catch (_) {
        stage = 'cart_read';
        httpStatus = 0;
        const cartResponse = await fetch(cartJsonUrl, { credentials: 'same-origin' });
        httpStatus = cartResponse.status;
        if (!cartResponse.ok) throw new Error('discount_http_error');
        return cartResponse.json();
      }
    };
    try {
      let cart = null;
      if (window.SBCart && typeof window.SBCart.applyDiscount === 'function') {
        stage = 'ajax_cart';
        try {
          cart = await window.SBCart.applyDiscount([code], { source: 'signup-popup-discount' });
        } catch (_) {}
      }
      if (!hasAcceptedCode(cart)) cart = await applyThroughDiscountRoute();
      if (hasAcceptedCode(cart)) return result(true, 'accepted');
      const entry = (Array.isArray(cart?.discount_codes) ? cart.discount_codes : [])
        .find((entry) => `${entry?.code || ''}`.trim().toLowerCase() === code.toLowerCase());
      return result(false, entry?.applicable === false && Number(cart?.item_count) > 0
        ? 'not_applicable' : 'not_confirmed');
    } catch (error) {
      return result(false, error?.message === 'discount_http_error' ? 'http_error'
        : error?.name === 'SyntaxError' ? 'invalid_response'
          : ['TypeError', 'AbortError', 'TimeoutError'].includes(error?.name) ? 'network_error' : 'unexpected_error');
    }
  };

  forms.forEach((form) => {
    const emailInput = form.querySelector('[data-sb-signup-popup-email]');
    const submitButton = form.querySelector('[data-sb-signup-popup-submit]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitButton?.disabled) return;
      const email = `${emailInput?.value || ''}`.trim();
      if (!email) return setFormError(form, root.dataset.errorRequired);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return setFormError(form, root.dataset.errorInvalid);

      syncAffiliateOffer();
      setFormError(form, '');
      submitButton?.classList.add('is-loading');
      if (submitButton) submitButton.disabled = true;
      try {
        const ok = await subscribe(email);
        if (!ok) return setFormError(form, root.dataset.errorGeneric);
        writeMemory({ subscribed: true });
        trackSignupEvent(email);
        syncTeaser();
        // Klaviyo signup is the primary action. Reveal the code immediately;
        // cart priming is a convenience and must never turn a completed signup
        // into a large customer-facing error.
        showState('success');
        const discountApplied = await applyDiscountToCheckout();
        trackDiscountResult(email, discountApplied);
      } catch (_) {
        setFormError(form, root.dataset.errorGeneric);
      } finally {
        submitButton?.classList.remove('is-loading');
        if (submitButton) submitButton.disabled = false;
      }
    });
  });

  // Step buttons: "advance" moves within the open dialog to the named
  // state, "dismiss" is a soft no - it closes like the X (same 5-day snooze).
  // Interest buttons remember the answer for the signup event.
  root.querySelectorAll('[data-sb-signup-popup-advance]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.dataset.sbSignupPopupInterest) selectedInterest = button.dataset.sbSignupPopupInterest;
      showState(button.dataset.sbSignupPopupAdvance);
    });
  });
  closeButton?.addEventListener('click', close);
  backdrop?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) close();
  });

  // Keep Tab cycling inside the dialog while the popup is open (aria-modal
  // promises assistive tech a modal; sighted keyboard users get one too).
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !isOpen() || !dialog) return;
    const focusables = [...dialog.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])')]
      .filter((el) => !el.matches(':disabled') && el.tabIndex >= 0
        && el.getClientRects().length > 0 && getComputedStyle(el).visibility === 'visible');
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (!root.contains(active)) {
      first.focus();
      event.preventDefault();
    } else if (event.shiftKey && (active === first || active === dialog)) {
      last.focus();
      event.preventDefault();
    } else if (!event.shiftKey && active === last) {
      first.focus();
      event.preventDefault();
    }
  });

  const shouldAutoOpen = () => {
    if (pageSuppressesAutoOpen) return false;
    if (window.Shopify?.designMode) return false;
    const memory = readMemory();
    if (memory.subscribed) return false;
    if (memory.dismissedAt && Date.now() - memory.dismissedAt < DISMISS_SNOOZE_MS) return false;
    return true;
  };

  const cookieBannerVisible = () => {
    const banner = document.getElementById('shopify-pc__banner');
    return !!banner && getComputedStyle(banner).display !== 'none';
  };

  // While the cookie banner is up, watch for the moment it actually leaves
  // (style flip or removal) rather than trusting event ordering - the
  // consent event can fire before the SDK hides the banner.
  let bannerWatcher = null;
  const armBannerWatch = () => {
    if (bannerWatcher) return;
    bannerWatcher = new MutationObserver(() => {
      if (cookieBannerVisible()) return;
      bannerWatcher.disconnect();
      bannerWatcher = null;
      attemptAutoOpen();
    });
    const banner = document.getElementById('shopify-pc__banner');
    if (banner) bannerWatcher.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
    const pageRoot = document.body || document.documentElement;
    if (pageRoot) bannerWatcher.observe(pageRoot, { childList: true, subtree: true });
  };

  const attemptAutoOpen = () => {
    if (!shouldAutoOpen() || isOpen()) return;
    if (cookieBannerVisible()) {
      armBannerWatch();
      return;
    }
    // In a background tab rAF is frozen and the lazy hero cannot load, so
    // opening now would strand a half-opened popup; first view re-triggers.
    if (document.visibilityState === 'hidden') {
      document.addEventListener('visibilitychange', () => attemptAutoOpen(), { once: true });
      return;
    }
    open();
  };

  if (shouldAutoOpen()) {
    // Immediate display: the form opens while the artwork decodes (the
    // Liquid promotes the fetch to high priority at parse time for eligible
    // visitors). The popup deliberately becomes the LCP element and is
    // engineered to paint fast, rather than hiding from the metric behind an
    // interaction gate - store testing showed immediate display converts
    // best. attemptAutoOpen still defers while the cookie banner is visible
    // (the popup must never cover consent UI) and re-arms on the consent
    // event. Artwork readiness never delays the form.
    attemptAutoOpen();
    // Shopify's consent API announces banner answers (accept, decline, or a
    // preferences save) with this event - the action-based "banner closed".
    document.addEventListener('visitorConsentCollected', () => attemptAutoOpen());
  }

  // Self-diagnosing: the privacy banner SDK phones home on init and fails
  // silently on the local dev proxy, so the pill reports what happened.
  const bannerDebugButton = document.querySelector('[data-sb-signup-popup-debug-banner]');
  const bannerDebugState = bannerDebugButton?.querySelector('[data-sb-signup-popup-debug-banner-state]');
  const setBannerDebugState = (text) => {
    if (bannerDebugState) bannerDebugState.textContent = text ? `: ${text}` : '';
  };
  const waitForCookieBannerApi = async () => {
    for (let attempt = 0; attempt < 30; attempt += 1) {
      if (typeof window.privacyBanner?.showBanner === 'function') return window.privacyBanner;
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }
    return null;
  };
  bannerDebugButton?.addEventListener('click', async () => {
    setBannerDebugState('loading');
    const privacyBanner = await waitForCookieBannerApi();
    if (!privacyBanner) return setBannerDebugState('no SDK');
    try {
      await privacyBanner.showBanner();
    } catch (error) {
      console.error('[sb-signup-popup] showBanner failed', error);
      return setBannerDebugState('threw (console)');
    }
    for (let attempt = 0; attempt < 24; attempt += 1) {
      if (cookieBannerVisible()) return setBannerDebugState('');
      await new Promise((resolve) => window.setTimeout(resolve, 50));
    }
    setBannerDebugState('no-op');
  });

  // Teaser: on utility pages or while a dismiss snooze is running,
  // a small tab on the left edge offers the way back in - until its own X,
  // which silences it for the rest of that snooze cycle.
  const teaser = document.querySelector('[data-sb-signup-popup-teaser]');
  const syncTeaser = () => {
    if (!teaser) return;
    const memory = readMemory();
    const snoozing = memory.dismissedAt && Date.now() - memory.dismissedAt < DISMISS_SNOOZE_MS;
    const teaserDismissed = memory.teaserDismissedAt && memory.teaserDismissedAt >= (memory.dismissedAt || 0);
    const showTeaser = Boolean(
      (snoozing || pageSuppressesAutoOpen)
      && !memory.subscribed
      && !teaserDismissed
      && !window.Shopify?.designMode
    );
    teaser.hidden = !showTeaser;
  };

  teaser?.querySelector('[data-sb-signup-popup-teaser-open]')?.addEventListener('click', open);

  teaser?.querySelector('[data-sb-signup-popup-teaser-close]')?.addEventListener('click', () => {
    writeMemory({ teaserDismissedAt: Date.now() });
    syncTeaser();
  });

  syncAffiliateOffer();
  syncTeaser();

  const themeDebugButton = document.querySelector('[data-sb-signup-popup-debug-theme]');
  themeDebugButton?.addEventListener('click', () => {
    const rootEl = document.documentElement;
    const next = rootEl.dataset.theme === 'light' ? 'dark' : 'light';
    rootEl.dataset.theme = next;
  });
})();
